/*
 * @Author: ldx
 * @Date: 2024-01-18 10:16:44
 * @LastEditors: ldx
 * @LastEditTime: 2024-01-18 17:15:41
 * @Description: 请求对象
 */
import axios from 'axios'

const _config = {
  baseURL: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_PROXY_OA,
  timeout: 30000,
  withCredentials: true,
}



class RequestHttp {
  _service = undefined;
  constructor(config) {
    this._service = axios.create(config);
    // 响应拦截器处理函数
    this._service.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      return error;
    });
    // 请求拦截器处理函数
    this._service.interceptors.request.use(function (request) {
      return request;
    }, function (error) {
      return error;
    })
  }

  get(url, params, object) {
    return this._service.get(encodeURI(url), { params, ...object })
  }
  post(url, params, object) {
    return this._service.post(url, params, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      }, ...object
    })
  }
}

export function createRequest(config = _config) {
  const opts = { ..._config }
  return new RequestHttp(Object.assign(opts, config))
}

export default createRequest();